<template>
  <div>
    <Title :pages="[{ icon: 'print', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td class="text-center">{{ item.printer_type }}</td>
              <td class="text-center">{{ item.ip }}</td>
              <td class="text-center">{{ item.port }}</td>
              <td>{{ item.printer_socket || '-' }}</td>
              <td>{{ item.ubicacion ? item.ubicacion.code : '-' }}</td>
              <td>{{ item.ubicacion && item.ubicacion.zona ? item.ubicacion.zona.almacen.name : '-' }}</td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { printerService } from "@/libs/ws/printerService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";

export default {
  components: { Modal },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: printerService,
      page_title: "Impresoras",
      modal_title: "Impresora",
      headers: [
        { title: "Nombre", align: "left", sortable: true, key: "name" },
        { title: "Tipo", align: "center", sortable: true, key: "printer_type" },
        { title: "IP", align: "center", sortable: true, key: "ip" },
        { title: "Puerto", align: "center", sortable: true, key: "port" },
        { title: "Socket", align: "left", sortable: true, key: "printer_socket" },
        { title: "Ubicacion", align: "left", sortable: true, key: "ubicacion.code" },
        { title: "Almacen", align: "left", sortable: true, key: "ubicacion.zona.almacen.name" },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadList(this.service);
  },
  methods: {},
};
</script>
